module.exports = __webpack_public_path__ + "img/title1.259c9420.png";